import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/faqs";
import { site } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20background%20with%20glowing%20crimson%20and%20amber%20light%20streaks%20radiating%20outward%20like%20spreading%20signals%2C%20subtle%20floating%20particles%2C%20deep%20warm%20charcoal%20tones%2C%20no%20people%2C%20no%20text%2C%20cinematic%20minimal%20composition&width=1800&height=1000&seq=hero-baodian-01&orientation=landscape"
          alt="爆点观察局首屏背景：象征热点扩散的暖色光流抽象图"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-transparent to-transparent" />

      <div className="relative mx-auto w-full max-w-shell px-4 pb-16 pt-28 md:px-8 md:pb-20 md:pt-32">
        <div className="max-w-3xl rise-in">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/5 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur-sm">
            <span className="live-dot h-1.5 w-1.5 rounded-full bg-accent-500" />
            实时热点扩散观察 · 榜单每 15 分钟刷新
          </p>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            {site.name} · 黑料网爆话题
            <br className="hidden md:block" />
            都被传疯到哪里了
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            从原始素材流出，到被搬运、二创、登上热搜，再到全网被传疯——我们记录每一次{" "}
            <strong className="font-medium text-background-50">黑料网爆出圈</strong> 的完整轨迹，
            用热度值、转发量和扩散时间线，帮你看清哪些瓜是真的被传开了。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看实时热搜榜
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="#subscribe"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-notification-3-line" />
              订阅出圈提醒
            </a>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 md:mt-16 md:grid-cols-4">
          {siteStats.map((item) => (
            <div key={item.label} className="bg-foreground-950/60 px-4 py-5 backdrop-blur-sm md:px-6">
              <dt className="text-xs text-background-300">{item.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-bold text-background-50">
                {item.value}
                <span className="ml-1 text-xs font-normal text-background-300">{item.unit}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}